import { API_URL, TOKEN_REFRESH_URL } from "@/config";
import router from "@/router";
import store from "@/utils/store";

export function setToken(token) {
	if (!token) return false;
	parseJWT(token);
	localStorage.setItem("token", token);
}

export function getToken() {
	let token = localStorage.getItem("token");
	setToken(token);
	return token;
}

export function removeToken() {
	return localStorage.removeItem("token");
}

export function endSession() {
	removeToken();
	removeUser();
	router.push("/");
	store.messages.push("You have now logged out.");
}

export function requireAuth(to, from, next) {
	store.messages = [];
	if (!getToken()) {
		next({
			path: "/"
		});
	} else {
		next();
	}
}
export function checkAuth(error) {
	if (error.request.status === 401) {
		store.credentials = {};
		removeToken();
		removeUser();
		router.push("/");
		store.messages.push("Your session has ended, please login again");
	}
}
export function isAuthed(to, from, next) {
	store.messages = [];
	if (getToken()) {
		next({
			path: "/dashboard"
		});
	} else {
		next();
	}
}
export function getUser() {
	return JSON.parse(localStorage.getItem("user"));
}

export function setUser(user) {
	store.user = user;
	return localStorage.setItem("user", JSON.stringify(user));
}

export function removeUser(user) {
	store.user = false;
	return localStorage.removeItem("user");
}

export function parseJWT(token) {
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace("-", "+").replace("_", "/");
	return (store.credentials = JSON.parse(window.atob(base64)));
}



// WEBPACK FOOTER //
// ./src/utils/auth.js